import { Checkbox, Group } from '@mantine/core';
import {
  IFormInputSpecComparator,
  IFormInputSpecComparatorOperator,
} from 'pages/revisions-module/template-editor/editors/form/types';
import InputMention from 'pages/revisions-module/template-editor/editors/InputMention';

interface ComparatorInputPreviewProps {
  spec: IFormInputSpecComparator;
}

const OPERATOR_LABEL: Record<IFormInputSpecComparatorOperator, string> = {
  empty: 'je prázdne',
  'not-empty': 'nie je prázdne',
  eq: '=',
  ne: '≠',
  gt: '>',
  lt: '<',
  gte: '≥',
  lte: '≤',
  'logical-and': 'a zároveň',
  'logical-or': 'alebo',
  'logical-not': 'negácia',
};

/**
 * Preview for the comparator input type.
 */
export default function ComparatorInputPreview({ spec }: ComparatorInputPreviewProps) {
  const isUnary = spec.operator === 'empty' || spec.operator === 'not-empty' || spec.operator === 'logical-not';

  return (
    <Checkbox
      size="sm"
      readOnly
      disabled
      label={
        <Group spacing={4} align="center" noWrap>
          {spec.operator === 'logical-not' ? OPERATOR_LABEL[spec.operator] : ''}
          <InputMention name={spec.fieldA} />
          {spec.operator !== 'logical-not' ? OPERATOR_LABEL[spec.operator] : ''}
          {!isUnary && <InputMention name={spec.fieldB || ''} />}
        </Group>
      }
    />
  );
}
